<template>
    <section class="popular-questions-preview">
        <div class="container">
            <div class="popular-questions-preview__wrapper" v-if="popularQuestions">
                <div class="popular-questions-preview__wrapper__main-question">
                    <h2>{{ popularQuestions.name }}</h2>
                </div>
                <div
                    class="popular-questions-preview__wrapper__slider"
                    ref="sliderContainer"
                    @mousedown="startDrag"
                    @mouseup="endDrag"
                    @mouseleave="endDrag"
                    @mousemove="handleDrag"
                >
                    <Card v-for="(item, index) in allPopularQuestions" :key="index" :item="item" />
                </div>
            </div>
            <div v-else-if="!isDataLoaded" class="popular-questions-preview__wrapper --empty">
                <MySkeleton class="popular-questions-preview__wrapper__card__intro" />
                <MySkeleton
                    :class="{
                        'popular-questions-preview__wrapper__card__item': true,
                        '--half-item': i === 3
                    }"
                    v-for="i in 3"
                    :key="i"
                />
            </div>
        </div>
    </section>
</template>

<script>
import VueTypes from 'vue-types';
import { createPopularQuestions, createPopularQuestionsItem, PopularQuestions } from './types';

export default {
    name: 'PopularQuestions',
    // props: {
    //     popularQuestions: VueTypes.oneOfType([PopularQuestions, VueTypes.nullable]).isRequired
    // },
    data() {
        return {
            popularQuestions: null,
            isDragging: false,
            startX: 0,
            scrollLeft: 0,
            isDataLoaded: false
        };
    },
    components: {
        Card: () => import('./components/Card'),
        MySkeleton: () => import('@/themes/novaporta/components/ui/MySkeleton')
    },
    computed: {
        allPopularQuestions() {
            return this.popularQuestions.questions;
        }
    },
    methods: {
        startDrag(event) {
            this.isDragging = true;
            this.startX = event.pageX - this.$refs.sliderContainer.offsetLeft;
            this.scrollLeft = this.$refs.sliderContainer.scrollLeft;
        },
        endDrag() {
            this.isDragging = false;
        },
        handleDrag(event) {
            if (!this.isDragging) return;
            const x = event.pageX - this.$refs.sliderContainer.offsetLeft;
            const walk = x - this.startX;
            this.$refs.sliderContainer.scrollLeft = this.scrollLeft - walk;
        },
        async fetchPopularQuestions() {
            const { data } = await this.$api.home.getPopularQuestions();

            if (data?.faq_items?.length) {
                this.popularQuestions = createPopularQuestions({
                    id: data.id,
                    name: data.name,
                    questions: data.faq_items.map(child => {
                        return createPopularQuestionsItem({
                            id: child.id,
                            answer: child.answer,
                            question: child.question
                        });
                    })
                });
            }
            this.isDataLoaded = true;
        }
    },
    async fetch() {
        await this.fetchPopularQuestions();
    }
};
</script>

<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
